import { render } from "./PokemonPicture.vue?vue&type=template&id=7c8c567c&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=7c8c567c&scoped=true&lang=css"

import exportComponent from "E:\\Jose Carlos\\Escritorio\\Vue\\05-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8c567c"]])

export default __exports__